import { Link } from "react-router-dom";
import { ArrowUpRight, BookOpen } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { useContent } from "@/lib/api";

export const BlogLinks = ({ page }) => {
  const { items } = useContent("posts");
  const posts = items.filter((p) => (p.link_pages || []).includes(page) || p.related_service === page);
  if (!posts.length) return null;
  return (
    <section className="bg-white py-16 sm:py-20" data-testid="service-blog-links">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <p className="eyebrow text-[#7C3AED]"><span className="h-1.5 w-1.5 rounded-full bg-[#2563EB]" />Helpful guides</p>
        <div className="mt-6 grid gap-4 md:grid-cols-2">
          {posts.map((p) => (
            <Reveal key={p.slug}>
              <Link to={`/blog/${p.slug}`} className="group flex h-full items-start gap-4 rounded-[24px] border border-violet-200 p-6 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(46,16,101,.35)]" data-testid={`service-blog-link-${p.slug}`}>
                <BookOpen className="mt-1 h-5 w-5 shrink-0 text-[#7C3AED]" aria-hidden />
                <span className="flex-1">
                  <span className="block text-lg font-extrabold leading-snug text-[#13052A]">{p.title}</span>
                  <span className="mt-1 block text-sm text-slate-600">{p.excerpt}</span>
                </span>
                <ArrowUpRight className="h-5 w-5 shrink-0 text-[#7C3AED] transition-transform duration-500 group-hover:-translate-y-1" />
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
